import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import JsonXml from '../../components/JsonXml.vue';
export default {
  __name: 'JsonXmlPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "JSON转XML / XML转JSON",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(JsonXml)]),
        _: 1
      });
    };
  }
};